import React from 'react';
import SharedPage from './shared';

const DesignPage = ({}) => {
  return <SharedPage pageType="design" />;
};

export default DesignPage;
